<template>
    <span class="toggle" role="checkbox" tabindex="0"
          @click="toggle"
          @keydown.space.prevent="toggle"
          :aria-checked="value"
    ></span>
</template>

<script>
    export default {
        props: ['subscription', 'user'],

        data() {
            return {
                value: false,
                verb: 'post'
            }
        },

        watch: {
            user() {
                this.active();
            }
        },

        methods: {
            toggle() {
                this.value ? this.unsubscribe() : this.subscribe()
                this.$emit('subscription-changed');
            },

            active() {
                this.value = this.user.subscriptions.some(sub => sub.id == this.subscription);
            },

            unsubscribe() {
                axios.delete(`/subscriptions/${this.subscription}/subscribe`, { data: {user_id: this.user.id}})
                    .then(() => {
                        this.value = ! this.value;
                    })
            },

            subscribe() {
                axios.post(`/subscriptions/${this.subscription}/subscribe`, {user_id: this.user.id})
                    .then(() => {
                        this.value = ! this.value;
                    })
            }
        }
    }
</script>
